import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";
import bodyStyles from "./bodyStyles";

const {
	breakPoints: { mobileFirstScreenQuery },
} = theme;

const Body4 = styled.p(
	bodyStyles,
	`
  font-size: 16px;
  line-height: 24px;
  ${mobileFirstScreenQuery.medium}{
    font-size: 18px;
    line-height: 27px;
  }
  
`
);

export default ({ children, ...props }) => <Body4 {...props}>{children}</Body4>;
